import '@angular/compiler'
import { enableProdMode } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import { Logger } from './app/angular-wallet-base/services/logger.service';

if (environment.features.sentry) {
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ["localhost", "https://wallet-v3.lode.one"],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: 0.0,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => Logger.info(err));
